export default __webpack_public_path__ + "static/media/ic_liechtenstein.5588bc1f.svg";